@if (!pageDataLoaded()) {
  <app-page-loading-state [loadingState]="loadingState"></app-page-loading-state>
}

<div class="row mt-3" [class.hide]="!pageDataLoaded()">
  <div class="col-12">
    @if (scan) {
      <app-view-scan-results
        [auditTool]="auditTool"
        [scanSummary]="scanSummary"
        [prevToolVersion]="previousScanSummary?.toolId.version"
        [currToolVersion]="scanSummary?.toolId.version"
        [scan]="scan"
        [standard]="standardAndLevel"
        [toolsUsed]="toolsUsed"
        (onAuditToolChange)="onAuditToolChange($event)"
      ></app-view-scan-results>
    }
  </div>
</div>
@if (auditTool === AccessibilityAuditToolNames.access_engine) {
  <ng-container *appHasPermissions="artScansAndMonitoringReadRequiredSecurity">
    <ng-container *featureFlag="FeatureFlags.artInScansAndMonitoring">
      @if (scanSummary && canARTImproveScore) {
        <div class="row mt-3">
          <ds-banner
            [state]="DsBannerState.info"
            [showTitle]="true"
            [title]="
              (digitalPropertyHasUserWayIntegration$ | async) && (tenantHasUserWayIntegration$ | async)
                ? ('automated_remediation_score_may_be_higher' | translate)
                : ('automated_remediation_available' | translate)
            "
            [showAction]="false"
            [showCloseButton]="false"
            data-test-id="art-scan-and-monitoring-banner"
          >
            <div ds-banner-body>
              @if ((digitalPropertyHasUserWayIntegration$ | async) && (tenantHasUserWayIntegration$ | async)) {
                <span
                  data-test-id="art-banner-copy"
                  [innerHTML]="
                    'integrated_widget_art_banner_copy' | translateHtml: [simulatedARTScore, totalFindingsCountAfterART]
                  "
                ></span>
              } @else {
                <span
                  data-test-id="art-banner-copy"
                  [innerHTML]="'no_widget_art_banner_copy' | translateHtml: [simulatedARTScore, totalFindingsCountAfterART]"
                ></span>
              }
              @if (userWayBannerLink$ | async; as userWayBannerLink) {
                @if (userWayBannerLinkMessage$ | async; as userWayBannerLinkMessage) {
                  <ds-link class="ms-1" [standalone]="false" [external]="true" [href]="userWayBannerLink">
                    {{ userWayBannerLinkMessage | translate }}
                  </ds-link>
                }
              }
            </div>
          </ds-banner>
        </div>
      }
    </ng-container>
  </ng-container>
}
@if (pageDataLoaded()) {
  <div>
    @if (scanSummary && scanSummary[$scanSummaries.metrics]) {
      <div class="row mt-3">
        <div class="col-12 col-xl-4" id="accessibilityHealth">
          <app-view-scan-results-accessibility-health
            [scanSummary]="scanSummary"
            [previousScanSummary]="previousScanSummary"
          ></app-view-scan-results-accessibility-health>
        </div>
        <div class="col-12 col-xl-4 mt-3 mt-xl-0">
          @if (isWCAGScan) {
            <app-issues-by-wcag-level [auditTool]="auditTool" [scanSummary]="scanSummary"></app-issues-by-wcag-level>
          } @else {
            <app-issues-of-non-leveled-standard
              [auditTool]="auditTool"
              [scanSummary]="scanSummary"
            ></app-issues-of-non-leveled-standard>
          }
        </div>
        <div class="col-12 col-xl-4 mt-3 mt-xl-0">
          <app-view-scan-results-issues-by-severity
            [auditTool]="auditTool"
            [scanSummary]="scanSummary"
            [customSeverities]="customSeverities$ | async"
          ></app-view-scan-results-issues-by-severity>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <app-view-scan-results-aggregated-issues
            [scan]="scan"
            [scanSummary]="scanSummary"
            [auditTool]="auditTool"
            [scanAudit]="scanAudit"
            [workspaceId]="workspaceId"
            [digitalPropertyId]="digitalPropertyId"
            [canViewByComponent]="canViewByComponent"
          >
          </app-view-scan-results-aggregated-issues>
        </div>
      </div>
    } @else {
      <div class="row mt-3">
        <div class="col-12">
          <div class="card">
            <div class="card-body my-5">
              <div class="row">
                <div class="col-12 d-flex flex-column justify-content-center align-items-center">
                  <ng-container *featureFlag="FeatureFlags.dsPageMessage">
                    <ds-page-message
                      [title]="'no_scan_results_available' | translate"
                      [toggleBody]="true"
                      [setPageMessageVariant]="DsPageMessageVariants.info"
                      [pageMessageIcon]="Icons.ScanBrand"
                      [iconColor]="DsColors.Primary"
                      [iconScale]="IconScale.FA_4X"
                      [iconStyle]="IconStyles.Light"
                      [togglePadding]="false"
                      titleHeadingStyle="h3"
                    >
                      <div ds-page-message-body>{{ 'no_scan_results_available_subtitle' | translate }}</div>
                    </ds-page-message>
                  </ng-container>
                  <ng-container *featureFlag="revertFlag(FeatureFlags.dsPageMessage)">
                    <svg aria-hidden="true" width="68" height="96" fill="none">
                      <use xlink:href="#clipboard-red"></use>
                    </svg>
                    <h3 class="mt-4 mb-2">{{ 'no_scan_results_available' | translate }}</h3>
                    <p>{{ 'no_scan_results_available_subtitle' | translate }}</p>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (scan) {
      <div class="row mt-3">
        <div class="col-12">
          <app-view-scan-results-scannable-documents [scan]="scan"> </app-view-scan-results-scannable-documents>
        </div>
      </div>
    }
    @if (scan) {
      <div class="row mt-3">
        <div class="col-12">
          <app-view-scan-results-pages-not-scanned
            [scan]="scan"
            [auditTool]="auditTool"
            [workspaceId]="workspaceId"
            [digitalPropertyId]="digitalPropertyId"
          >
          </app-view-scan-results-pages-not-scanned>
        </div>
      </div>
    }
  </div>
}
